import { Component, Inject, OnInit } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { PageEvent } from '@angular/material/paginator'
import { takeUntil } from 'rxjs'

import { DestroyService } from '@core/services/destroy.service'
import { PagesData } from '@shared/models/pages-data.model'
import { History } from '@shared/models/history.model'
import { StatusHistoryDataService } from './status-history-data.service'
import { DevicesService } from '@shared/modules/devices/devices.service'

interface HistoryDialogData {
  history: History[]
  type?: string
  deviceId?: string
}

@Component({
  selector: 'lin-status-history-dialog',
  templateUrl: './status-history-dialog.component.html',
  styleUrls: ['./status-history-dialog.component.scss'],
  providers: [DestroyService],
  standalone: false,
})
export class StatusHistoryDialogComponent implements OnInit {
  displayData: History[]
  total: number
  isShowPagination: boolean

  customHeaderTypes = ['contract', 'clientContract', 'device.phone.changed']
  customDataTypes = ['contract', 'unavailable', 'deactivated']

  constructor(
    public dialogRef: MatDialogRef<StatusHistoryDialogComponent>,
    private readonly statusHistoryDataService: StatusHistoryDataService,
    private readonly deviceService: DevicesService,
    private readonly destroyService: DestroyService,
    @Inject(MAT_DIALOG_DATA) public data: HistoryDialogData,
  ) {}

  ngOnInit(): void {
    if (Array.isArray(this.data.history)) {
      this.displayData = this.data.history
    } else {
      this.statusHistoryDataService.historyData$.pipe(takeUntil(this.destroyService)).subscribe(({ data, meta }: PagesData<History>) => {
        this.displayData = data
        this.total = meta.total
        this.isShowPagination = meta?.total > 10
      })
    }
  }

  onPageChange(event: PageEvent): void {
    this.deviceService
      .getDeviceStatusHistory(this.data.deviceId, event.pageIndex + 1, event.pageSize)
      .pipe(takeUntil(this.destroyService))
      .subscribe((data) => this.statusHistoryDataService.setHistoryData(data))
    this.statusHistoryDataService.setPageEvent(event)
  }
}
